import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import MaterialUI from "../../../../../../../material-UI";

interface Props {
  onClose: () => void;
  onCloseProposta: () => void;
}

const Footer: React.FC<Props> = (props) => {
  const handleClick = () => {
    props.onClose();
    props.onCloseProposta();
  };

  return (
    <Styles.SecondContainer>
      <Styles.Button onClick={props?.onClose}>
        <Styles.LightTextBlue>Não</Styles.LightTextBlue>
      </Styles.Button>
      <Styles.ButtonBlue
        onClick={() => {
          handleClick();
        }}
      >
        <Styles.LightText>Sim</Styles.LightText>
      </Styles.ButtonBlue>
    </Styles.SecondContainer>
  );
};

export default Footer;
